/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {ModalController} from "@ionic/angular";

@Component({
  selector: "c3-notification-info-dialog",
  templateUrl: "./notification-info-dialog.component.html",
  styleUrls: ["./notification-info-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NotificationInfoDialogComponent {
  @Input()
  showEnableBtn?: boolean;

  constructor(private modalCtrl: ModalController) { }

  onDismiss(enableNotification?: boolean) {
    this.modalCtrl.dismiss(enableNotification);
  }
}
